import React from "react";
import { InlineSpinner } from "./SourceMessageAccordion";

/**
 * Centers a loading spinner in the available business page area.
 *
 * @example
 * if (loading) return <BusinessPageLoader text="Loading action items…" />;
 */
export const BusinessPageLoader = ({ text = "Loading…" }) => (
  <div className="business-page-loader">
    <InlineSpinner text={text} />
  </div>
);

export default BusinessPageLoader;
